import { RecordCategoryType, Scope, RecordCategory } from 'queries/events/records/types';

export const formatUserName = (user_email: string) => {
  return user_email.split('@')[0];
};

const i18nPrefix = {
  default: 'records:values',
  case: 'case:records',
};

export const getTranslationPath = (category: RecordCategoryType, scope?: Scope): string => {
  switch (true) {
    case scope === Scope.CASE:
      return i18nPrefix.case;
    case category === RecordCategory.UPDATED:
      return `components:${scope}`;
    case category === RecordCategory.ACTION_UPDATED:
      return i18nPrefix.case;
    default:
      return i18nPrefix.default;
  }
};
